import script from "./ChatsView.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChatsView.vue?vue&type=script&setup=true&lang=ts"

import "./ChatsView.vue?vue&type=style&index=0&id=30b39cef&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-30b39cef"]])

export default __exports__